import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useEditPlaylist = ({ onSuccess }) => {
  const { onSubmit: handleEdit } = useFetch('edit-playlist', Api.EDIT_PLAYLIST);

  const onEditPlaylist = (id, item, key) => (value) => {
    handleEdit({
      method: 'PUT',
      pathParams: { id },
      onSuccess,
      body: Object.assign({}, item, { [key]: value }),
    });
  };

  return {
    onEditPlaylist,
  };
};

export default useEditPlaylist;
